import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFloppyDisk, faPaperPlane, faSave } from "@fortawesome/free-solid-svg-icons";
import downloadHandler from "@serie3/freelancesplaceapi/Domain/Shared/downloadHandler";
import PDFModal from "../../../../../../../layout/Popups/PDFModal";

const SubmitButtons = ({ formik, bill, forceShow }) => {
  const [showSpinner, setShowSpinner] = useState(false);

  const setKundeOrPerson = () => {
    if (formik.values.hasOwnProperty("kunde")) {
      const customer = formik.getFieldProps("kunde").value;
      if (customer != null) {
        formik.setFieldValue("kunde", null);
        formik.setFieldValue("kunde", { id: customer.id });
        formik.setFieldValue("person", null);
      }
    }
    if (formik.values.hasOwnProperty("person")) {
      const person = formik.getFieldProps("person").value;
      if (person != null) {
        formik.setFieldValue("person", null);
        formik.setFieldValue("person", { id: person.id });
        formik.setFieldValue("kunde", null);
      }
    }
  };

  if (!bill.draft && !forceShow) return null;

  return (
    <>
      <PDFModal showSpinner={showSpinner} setShowSpinner={setShowSpinner} />
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "8px" }}>
        <button
          type="submit"
          onClick={(e) => {
            setKundeOrPerson();
            formik.handleSubmit(e);
            e.preventDefault();
          }}
          style={{
            display: "inline-flex", alignItems: "center", gap: "7px",
            padding: "9px 18px", background: "#1a73e8", color: "#fff",
            border: "none", borderRadius: "8px", fontWeight: 600,
            fontSize: "0.88rem", cursor: "pointer",
            boxShadow: "0 2px 8px rgba(26,115,232,0.25)",
          }}
        >
          <FontAwesomeIcon icon={faSave} /> Save
        </button>
        <button
          type="submit"
          onClick={(e) => {
            formik.setFieldValue("draft", true);
            formik.handleSubmit(e);
            setKundeOrPerson();
            e.preventDefault();
          }}
          style={{
            display: "inline-flex", alignItems: "center", gap: "7px",
            padding: "9px 18px", background: "#f5f5f5", color: "#424242",
            border: "none", borderRadius: "8px", fontWeight: 600,
            fontSize: "0.88rem", cursor: "pointer",
          }}
        >
          <FontAwesomeIcon icon={faFloppyDisk} /> Save as Draft
        </button>
        <button
          type="submit"
          onClick={(e) => {
            setShowSpinner(true);
            formik.setFieldValue("draft", false);
            setKundeOrPerson();
            formik.handleSubmit(e);
            e.preventDefault();
            downloadHandler("finance/print/" + bill.id, "Bill-" + bill.id + ".pdf", null, setShowSpinner);
          }}
          style={{
            display: "inline-flex", alignItems: "center", gap: "7px",
            padding: "9px 18px", background: "#2e7d32", color: "#fff",
            border: "none", borderRadius: "8px", fontWeight: 600,
            fontSize: "0.88rem", cursor: "pointer",
            boxShadow: "0 2px 8px rgba(46,125,50,0.25)",
          }}
        >
          <FontAwesomeIcon icon={faPaperPlane} /> Publish
        </button>
      </div>
    </>
  );
};

export default SubmitButtons;
